export enum ComSendType {
    SEND = 1,
    FORWARD = 2
}